unit UTagKzList;

interface

uses
  System.Contnrs, UTagKzModel, UEssentialHelper, Js;

type
  TTagKzList = class(TObjectList)
  private
    FOnPropertyChanged: TCallback;
    function GetItem(i: Integer): TTagKzModel;
    procedure PropertyChanged;
    procedure SetValues(obj: TJsObject); overload;
    procedure SetValues(json: string); overload;
    procedure SetOnPropertyChanged(const Value: TCallback);
  public
    function GetItemByDatum(datum: TDateTime): TTagKzModel;
    procedure Add(item: TTagKzModel);
    procedure GetAll(url: string; personalNr: string; jahr: Integer);
    property Items[i: Integer]: TTagKzModel read GetItem;
    property OnPropertyChanged: TCallback read FOnPropertyChanged write SetOnPropertyChanged;
  end;

implementation

uses
  System.SysUtils, WebLib.JSON,WebLib.REST;

{ TTagKzList }

procedure TTagKzList.Add(item: TTagKzModel);
begin
  inherited Add(item);
end;

procedure TTagKzList.GetAll(url, personalNr: string; jahr: Integer);
var obj: TJsonObject;
    helper: string;
    client: TRestClient;
  procedure Response(Sender: TObject; aResponse: string);
  var jso: TJsObject;
  begin
    jso:=TJsJson.parseObject(AResponse);
    if jso['value']<>nil then
      Self.SetValues(string(jso['value']));
    Self.PropertyChanged;
  end;
begin
  obj:=TJsonObject.Create;
  obj.AddPair('PersonalNr',personalNr);
  obj.AddPair('Jahr',IntToStr(jahr));
  helper:=obj.ToString;
  obj:=TJsonObject.Create;
  obj.AddPair('value',helper);
  client:=TRestClient.Create(nil);
  client.OnResponse:=Response;
  client.HttpsPost(url+'/TagKzService/GetAll','application/json',obj.ToString);
  client.Free;
  obj.Free;
end;

function TTagKzList.GetItem(i: Integer): TTagKzModel;
begin
  Result:=inherited GetItem(i) as TTagKzModel;
end;

function TTagKzList.GetItemByDatum(datum: TDateTime): TTagKzModel;
var i: Integer;
    found: Boolean;
begin
  found:=false;
  i:=0;
  while not found and (i<Self.Count) do
    if Trunc(Self.Items[i].Datum)=Trunc(datum) then
      found:=true
    else
      Inc(i);
  if found then
    Result:=Self.Items[i]
  else
    Result:=nil;
end;

procedure TTagKzList.PropertyChanged;
begin
  if Assigned(Self.OnPropertyChanged) then
    Self.OnPropertyChanged(Self);
end;

procedure TTagKzList.SetOnPropertyChanged(const Value: TCallback);
begin
  FOnPropertyChanged := Value;
end;

procedure TTagKzList.SetValues(json: string);
var obj: TJsObject;
begin
  obj:=TJsJson.parseObject(json);
  Self.SetValues(obj);
end;

procedure TTagKzList.SetValues(obj: TJsObject);
var i, count: Integer;
begin
  Self.Clear;
  if obj['Count']<>nil then begin
    count:=StrToInt(string(obj['Count']));
    for i:=0 to count-1 do
      if obj['Item'+IntToStr(i)]<>nil then
        Self.Add(TTagKzModel.Create(string(obj['Item'+IntToStr(i)])));
  end;
end;

end.
